import React from 'react';
import ReactModal from 'react-modal';
import { toString } from '../../utils/string';

interface Props {
  active: boolean;
  additionalClassName?: string | undefined;
  displayCloseButton: boolean;
  shouldCloseOnOverlayClick?: boolean | undefined;
  children: React.ReactNode;
  onClose?: () => void | undefined;
  modalClassName?: string | undefined;
}

/**
 * モーダルの共通コンポーネント
 * @param
 * @returns
 */
function Modal({
  active,
  additionalClassName,
  displayCloseButton,
  shouldCloseOnOverlayClick,
  children,
  onClose,
  modalClassName,
}: Props) {
  return (
    <ReactModal
      isOpen={active}
      overlayClassName={`modal-container ${active ? 'active' : ''}`}
      className={modalClassName === undefined ? "modal-body" : modalClassName}
      onRequestClose={onClose}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <div className="modal-content" onClick={onClose}>
        <div
          className={`popupfr ${toString(additionalClassName)}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {displayCloseButton && (
            <button type="button" className="modal-close text-button" onClick={onClose}>
              ×
            </button>
          )}
          {children}
        </div>
      </div>
    </ReactModal>
  );
}

Modal.defaultProps = {
  onClose: undefined,
  additionalClassName: undefined,
  shouldCloseOnOverlayClick: undefined,
  modalClassName: undefined,
};

export default Modal;
